import React from 'react';
import { X, Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function DifferentiatorSection() {
  const notThis = ['Otra dieta', 'Otro plan imposible', 'Otro consejo genérico'];
  const isThis = ['Un sistema específico para menopausia', 'Basado en ciencia real', 'Diseñado para aplicarlo HOY'];
  return <section className="py-24 bg-white relative" data-id="element-62">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-63">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-64">
          <FadeIn delay={0.1} data-id="element-65">
            <div className="bg-cream-alt rounded-3xl p-8 md:p-10 border border-cream-dark/50 opacity-80" data-id="element-66">
              <h3 className="text-2xl font-serif font-bold text-charcoal-muted mb-8 text-center" data-id="element-67">
                Esto NO es:
              </h3>
              <ul className="space-y-6" data-id="element-68">
                {notThis.map((item, index) => <li key={index} className="flex items-center gap-4" data-id="element-69">
                    <div className="bg-charcoal-muted/10 p-2 rounded-full text-charcoal-muted" data-id="element-70">
                      <X className="w-5 h-5" strokeWidth={3} data-id="element-71" />
                    </div>
                    <span className="text-lg font-medium text-charcoal-muted line-through decoration-charcoal-muted/30" data-id="element-72">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-73">
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-warm-lg border-2 border-terracotta/20 relative transform md:-translate-y-4" data-id="element-74">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-terracotta text-white px-6 py-1.5 rounded-full text-sm font-bold tracking-wide uppercase shadow-sm" data-id="element-75">
                La Diferencia
              </div>
              <h3 className="text-2xl font-serif font-bold text-terracotta-dark mb-8 text-center mt-4" data-id="element-76">
                Esto SÍ es:
              </h3>
              <ul className="space-y-6" data-id="element-77">
                {isThis.map((item, index) => <li key={index} className="flex items-center gap-4" data-id="element-78">
                    <div className="bg-terracotta/10 p-2 rounded-full text-terracotta" data-id="element-79">
                      <Check className="w-5 h-5" strokeWidth={3} data-id="element-80" />
                    </div>
                    <span className="text-lg font-bold text-charcoal" data-id="element-81">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}